import React from 'react';
import './Homepage.css';
import mapBackground from '../assets/images/map-image.png';

const Homepage = ({ onLoginClick }) => {
  return (
    <div 
      className="homepage"
      style={{
        '--map-background': `url(${mapBackground})`
      }}
    >
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">Popmates</div>
          <button className="login-button" onClick={onLoginClick}>
            Login
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">Hungry? Same!</h1>
          <h2 className="hero-subtitle">Let's grab a bite!</h2>
          <p className="hero-description">
            Discover new places, and meet new people, <strong>right now!</strong>
          </p>
          <button className="cta-button" onClick={onLoginClick}>
            See what's poppin' <span className="arrow">→</span>
          </button>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works">
        <div className="container">
          <h2 className="section-title">How It Works</h2>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3 className="step-title">Spot a Place</h3>
              <p className="step-description">
                See somewhere that looks good? 
                Great start
              </p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3 className="step-title">Show You're Interested</h3>
              <p className="step-description">
                Flag that you're thinking of 
                heading there
              </p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3 className="step-title">Quick Connect</h3>
              <p className="step-description">
                Match with others eyeing the 
                same spot
              </p>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <h3 className="step-title">Just Show Up</h3>
              <p className="step-description">
                Meet, eat, chat. Simple as that.
              </p>
            </div>
          </div>
          <button className="section-cta-button" onClick={onLoginClick}>
            Get Poppin'
          </button>
        </div>
      </section>

      {/* The Popmates Approach */}
      <section className="approach">
        <div className="container">
          <h2 className="section-title">The Popmates Approach</h2>
          <div className="approach-items">
            <div className="approach-item">
              <div className="approach-icon">🍽️</div>
              <h3>It's About the Place</h3>
              <p>The restaurant is what brings out your profile</p>
            </div>
            <div className="approach-item">
              <div className="approach-icon">⏰</div>
              <h3>Right Now, Not Later</h3>
              <p>Because hunger doesn't like to wait</p>
            </div>
            <div className="approach-item">
              <div className="approach-icon">😊</div>
              <h3>Actually Casual</h3>
              <p>No need for fancy bios, just bring your appetite</p>
            </div>
            <div className="approach-item">
              <div className="approach-icon">✨</div>
              <h3>Refreshingly Simple</h3>
              <p>See spot, like spot, meet at spot. Done.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why People Use It */}
      <section className="why-people-use">
        <div className="container">
          <h2 className="section-title">Why People Use It</h2>
          <div className="reasons">
            <div className="reason-card">
              <h3>Solo Dining Is Overrated</h3>
              <p>Food's better with someone across the table</p>
            </div>
            <div className="reason-card">
              <h3>Skip the Small Talk</h3>
              <p>You already have something in common: where you want to eat</p>
            </div>
            <div className="reason-card">
              <h3>No Overthinking</h3>
              <p>The hardest decision is still just what to order</p>
            </div>
            <div className="reason-card">
              <h3>Meet, Eat, Repeat</h3>
              <p>Or don't. No expectations either way</p>
            </div>
          </div>
          <button className="section-cta-button" onClick={onLoginClick}>
            Get Poppin'
          </button>
        </div>
      </section>

      {/* About Section */}
      <section className="about">
        <div className="container">
          <h2 className="section-title">What We're About</h2>
          <p className="about-text">
            "We figured out that everyone needs to eat and most people enjoy 
            company. So we connected those dots without adding any complicated 
            lines."
          </p>
        </div>
      </section>

      {/* Testimonial */}
      <section className="testimonial">
        <div className="container">
          <blockquote className="testimonial-quote">
            "Used Popmates when I wanted ramen but my friends were busy. Met 
            someone who knows way more about noodles than I do. Didn't have to 
            pretend it was anything more than two hungry people eating good food."
          </blockquote>
        </div>
      </section>

      {/* Final CTA */}
      <section className="final-cta">
        <div className="container">
          <h2 className="cta-title">Food now. Company included. That's it.</h2>
          <button className="cta-button large" onClick={onLoginClick}>
            See what's poppin' <span className="arrow">→</span>
          </button>
        </div>
      </section>
    </div>
  );
};

export default Homepage; 